import { useMutation } from "@apollo/client/react";
import NetworkStateContext from "contexts/NetworkStateContext";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import { useNotificationState, useSchedulerState } from "hooks/state";
import flatten from "lodash/flatten";
import values from "lodash/values";
import { useContext } from "react";
import GqlError from "utils/GqlError";
import StringUtils from "utils/StringUtils";
import TimeZone from "utils/TimeZone";
import { CloseGap } from "./block.gql";

export default function useCloseGap() {
  const { setNotification } = useNotificationState();
  const { trackLoadingState, isFetching } = useContext(NetworkStateContext);
  const [closeGap] = useMutation(CloseGap, {
    onCompleted: ({ closeGap: { blocks } }) => {
      const blockCount = blocks.workBlocks.length + blocks.downtimeBlocks.length;
      setNotification({
        message: `${blockCount} ${StringUtils.pluralize("block", blockCount)} shifted to the left.`,
        title: "Gap closed successfully",
        type: "success",
      });
    },
    onError: (error) => {
      GqlError.handler(error, (errors) => {
        const allErrors = flatten(values(errors)).join("\n");

        setNotification({
          message: "",
          title: allErrors,
          type: "danger",
        });
      });
    },
  });
  const applicationContext = useApplicationContext();
  const {
    state: { dataTimeRange },
  } = useSchedulerState();

  const handleCloseGap = ({ date, lineId }) => {
    trackLoadingState("CLOSE_GAP", () =>
      closeGap({
        variables: {
          clickedTime: TimeZone.overrideZone(date, applicationContext.timeZone.name),
          endsAt: TimeZone.overrideZone(dataTimeRange.endDate, applicationContext.timeZone.name),
          lineId,
          startsAt: TimeZone.overrideZone(dataTimeRange.startDate, applicationContext.timeZone.name),
        },
      }),
    );
  };

  return {
    fetching: isFetching("CLOSE_GAP"),
    handleCloseGap,
  };
}
